import type { PrescriptionReportRow, PrescriptionsReportResult } from "./types";

export interface RawPrescriptionReportRow {
  prescription_id: string;
  medical_record_id: string | null;
  issued_at: string | null;
  sequence_value: number | string | null;
  identifier: string | null;
  pet_id: string | null;
  pet_name: string | null;
  owner_id: string | null;
  owner_name: string | null;
  vet_name: string | null;
  signed_at: string | null;
  total_count: number | string;
}

const toNumber = (value: number | string): number => {
  const parsed = typeof value === "number" ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function formatSequence(value: number | null): string {
  if (value === null) return "—";
  return String(value).padStart(5, "0");
}

export function mapReportRows(
  raw: RawPrescriptionReportRow[] | null | undefined,
): PrescriptionsReportResult {
  if (!raw || raw.length === 0) return { rows: [], totalCount: 0 };

  const rows: PrescriptionReportRow[] = raw.map((row) => ({
    id: row.prescription_id,
    medicalRecordId: row.medical_record_id,
    issuedAt: row.issued_at,
    sequence: row.sequence_value === null ? null : toNumber(row.sequence_value),
    identifier: row.identifier,
    petId: row.pet_id,
    petName: row.pet_name,
    ownerId: row.owner_id,
    ownerName: row.owner_name,
    vetName: row.vet_name,
    signed: row.signed_at !== null,
  }));

  return { rows, totalCount: toNumber(raw[0].total_count) };
}
